var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{ref:"search",staticClass:"search-box",attrs:{"append-icon":"search","placeholder":"検索","background-color":"white"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onTextEnter.apply(null, arguments)},"input":_vm.inputKeyword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }